import { render } from "./EgiszPatientsDatatableTDName.vue?vue&type=template&id=c1dee4aa"
import script from "./EgiszPatientsDatatableTDName.vue?vue&type=script&lang=js"
export * from "./EgiszPatientsDatatableTDName.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__